import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import { useTranslation } from '@/i18n/client';

interface Iprops {
  className?: string;
  isLoading?: boolean;
}
export default function NoteTip(props: Iprops): JSX.Element {
  const { isLoading, className } = props;
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        ' w-fit px-2 py-[2px] bg-[#FEFDFF] border border-solid border-[#EEE9E4] rounded-[30px] transition-all z-[1] leading-[18px]',
        className
      )}
    >
      <span
        className={classNames('bg-gradient-to-r from-[#FFB959] to-[#7B67EF] bg-clip-text')}
        style={{ WebkitTextFillColor: 'transparent' }}
      >
        {isLoading ? (
          <>
            {t('memoryDetail.thinking')} <LoadingOutlined spin style={{ color: '#7B67EF' }} />
          </>
        ) : (
          t('memoryDetail.aha')
        )}
      </span>
    </div>
  );
}
